import { Navigate, createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import { useHasTool } from "../access/AccessProvider";
import {
  parseEventQueueSearch,
  type EventQueueSearch,
} from "../tools/event-queue/eventQueueSearch";
import { getLazyToolComponent } from "../tools/registry";

function EventQueueToolRoute() {
  const hasEventQueue = useHasTool("event-queue");
  if (!hasEventQueue) {
    return <Navigate to="/settings" replace />;
  }

  const EventQueueToolLayout = getLazyToolComponent("event-queue");
  if (!EventQueueToolLayout) {
    return <Navigate to="/settings" replace />;
  }

  return (
    <Suspense
      fallback={
        <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
          Loading Event queue…
        </div>
      }
    >
      <EventQueueToolLayout />
    </Suspense>
  );
}

export const Route = createFileRoute("/_app/event-queue")({
  component: EventQueueToolRoute,
  validateSearch: (search: Record<string, unknown>): EventQueueSearch =>
    parseEventQueueSearch(search),
});
